import {
    CREATE_STITCHING_DC_DETAILS_FAILURE_DK,
    CREATE_STITCHING_DC_DETAILS_REQUEST_DK,
    CREATE_STITCHING_DC_DETAILS_SUCCESS_DK,
    CREATE_USER_FORM_STITCHING_DC_DETAILS_DK,
    DELETE_STITCHING_DC_DETAILS_FAILURE_DK,
    DELETE_STITCHING_DC_DETAILS_REQUEST_DK,
    DELETE_STITCHING_DC_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_STITCHING_DC_DETAILS_FAILURE_DK,
    FETCH_SINGLE_STITCHING_DC_DETAILS_REQUEST_DK,
    FETCH_SINGLE_STITCHING_DC_DETAILS_SUCCESS_DK,
    FETCH_STITCHING_DC_DETAILS_FAILURE_DK,
    FETCH_STITCHING_DC_DETAILS_REQUEST_DK,
    FETCH_STITCHING_DC_DETAILS_SUCCESS_DK,
    STITCHING_DC_DETAILS_USERFORM_RESET_DK,
    UPDATE_STITCHING_DC_DETAILS_FAILURE_DK,
    UPDATE_STITCHING_DC_DETAILS_REQUEST_DK,
    UPDATE_STITCHING_DC_DETAILS_SUCCESS_DK,
    FETCH_STITCHING_DC_DETAILS_BY_ID_REQUEST_DK,
    FETCH_STITCHING_DC_DETAILS_BY_ID_SUCCESS_DK,
    FETCH_STITCHING_DC_DETAILS_DC_NO_REQUEST_DK_DK,
    FETCH_STITCHING_DC_DETAILS_DC_NO_SUCCESS_DK_DK,
    FETCH_STITCHING_DC_DETAILS_DC_NO_FAILURE_DK_DK,
    FETCH_GRN_NO_BY_STITCHING_DC_NO_REQUEST_DK_DK,
    FETCH_GRN_NO_BY_STITCHING_DC_NO_SUCCESS_DK_DK,
    FETCH_GRN_NO_BY_STITCHING_DC_NO_FAILURE_DK_DK,
    FETCH_STITCHING_DC_DETAILS_PROGRAM_REQUEST_DK,
    FETCH_STITCHING_DC_DETAILS_PROGRAM_SUCCESS_DK,
    FETCH_STITCHING_DC_DETAILS_PROGRAM_FAILURE_DK,
    FETCH_STITCHING_DC_DETAIL_EDIT_QUANTITY_SUCCESS_DK,
    FETCH_STITCHING_DC_DETAIL_EDIT_QUANTITY_REQUEST_DK,
    FETCH_STITCHING_DC_DETAIL_EDIT_QUANTITY_FAILURE_DK,
    CREATE_STITCHING_DC_DETAIL_EDIT_QTY_MASTER_REQUEST_DK,
    CREATE_STITCHING_DC_DETAIL_EDIT_QTY_MASTER_SUCCESS_DK,
    CREATE_STITCHING_DC_DETAIL_EDIT_QTY_MASTER_FAILURE_DK,
    CREATE_USER_FORM_STITCHING_DC_EDIT_QTY_DK,
    RESET_STITCHING_DC_EDIT_QTY_DK
} from './stitchingDCDetails.actionsType';

export const STITCHING_DC_DETAILS_DK = 'stitchingDcDetailsDK';

let initialState = {
    loading: false,
    stitchingDCDetailsById: [],
    stitchingDCDetails: [],
    stitchingDCDetailsDcNo: [],
    grnNoByStitchingDcNo: [],
    editStitchingQtyList: [],
    stitchingDCDetailsProgram: [],
    userform: {
        fldRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0
    },
    selectedStitchingDC2Details: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let stitchingDCDetailsDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_STITCHING_DC_DETAILS_REQUEST_DK:
        case FETCH_STITCHING_DC_DETAIL_EDIT_QUANTITY_REQUEST_DK:
        case FETCH_STITCHING_DC_DETAILS_PROGRAM_REQUEST_DK:
        case FETCH_GRN_NO_BY_STITCHING_DC_NO_REQUEST_DK_DK:
        case FETCH_STITCHING_DC_DETAILS_DC_NO_REQUEST_DK_DK:
        case FETCH_STITCHING_DC_DETAILS_BY_ID_REQUEST_DK:
        case CREATE_STITCHING_DC_DETAILS_REQUEST_DK:
        case CREATE_STITCHING_DC_DETAIL_EDIT_QTY_MASTER_REQUEST_DK:
        case FETCH_SINGLE_STITCHING_DC_DETAILS_REQUEST_DK:
        case UPDATE_STITCHING_DC_DETAILS_REQUEST_DK:
        case DELETE_STITCHING_DC_DETAILS_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_STITCHING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                stitchingDCDetails: updatePayload
            };
        case FETCH_STITCHING_DC_DETAIL_EDIT_QUANTITY_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                editStitchingQtyList: updatePayload
            };
        case FETCH_STITCHING_DC_DETAILS_PROGRAM_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                stitchingDCDetailsProgram: updatePayload?.Program
            };
        case FETCH_STITCHING_DC_DETAILS_BY_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                stitchingDCDetailsById: updatePayload
            };
        case FETCH_GRN_NO_BY_STITCHING_DC_NO_SUCCESS_DK_DK:
            return {
                ...state,
                loading: false,
                grnNoByStitchingDcNo: updatePayload?.Inward
            };
        case CREATE_STITCHING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                editStitchingQtyList: updatePayload?.CUD
            };
        case CREATE_STITCHING_DC_DETAIL_EDIT_QTY_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                editStitchingQtyList: [],
                userform: {
                    ...state.userform,
                    InwardNO: []
                }
            };
        case RESET_STITCHING_DC_EDIT_QTY_DK:
            return {
                ...state,
                loading: false,
                editStitchingQtyList: []
            };
        case FETCH_STITCHING_DC_DETAILS_DC_NO_SUCCESS_DK_DK:
            return {
                ...state,
                loading: false,
                stitchingDCDetailsDcNo: updatePayload?.STD
            };
        case FETCH_SINGLE_STITCHING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedStitchingDC2Details: updatePayload[0],
                userform: updatePayload[0]
            };
        case UPDATE_STITCHING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedStitchingDC2Details: {},
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case DELETE_STITCHING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                selectedStitchingDC2Details: {}
            };

        case FETCH_STITCHING_DC_DETAILS_FAILURE_DK:
        case FETCH_STITCHING_DC_DETAIL_EDIT_QUANTITY_FAILURE_DK:
        case FETCH_STITCHING_DC_DETAILS_PROGRAM_FAILURE_DK:
        case FETCH_STITCHING_DC_DETAILS_DC_NO_FAILURE_DK_DK:
        case FETCH_GRN_NO_BY_STITCHING_DC_NO_FAILURE_DK_DK:
        case FETCH_SINGLE_STITCHING_DC_DETAILS_FAILURE_DK:
        case CREATE_STITCHING_DC_DETAILS_FAILURE_DK:
        case CREATE_STITCHING_DC_DETAIL_EDIT_QTY_MASTER_FAILURE_DK:
        case UPDATE_STITCHING_DC_DETAILS_FAILURE_DK:
        case DELETE_STITCHING_DC_DETAILS_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_STITCHING_DC_DETAILS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case CREATE_USER_FORM_STITCHING_DC_EDIT_QTY_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    editStitchingQtyList: payload
                }
            };
        case STITCHING_DC_DETAILS_USERFORM_RESET_DK:
            return {
                ...state,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                selectedStitchingDC2Details: {}
            };
        default:
            return state;
    }
};
